import api from "./api";

/* LIST TASKS */
export const getTasks = async (params = {}) => {
  const response = await api.get("tasks/", { params });
  return response.data;
};

/* MY TASKS */
export const getMyTasks = async (params = {}) => {
  const response = await api.get("tasks/my-tasks/", { params });
  return response.data;
};

/* GET TASK */
export const getTaskById = async (id) => {
  const response = await api.get(`tasks/${id}/`);
  return response.data;
};

/* CREATE TASK */
export const createTask = async (data) => {
  const response = await api.post("tasks/", data);
  return response.data;
};

/* UPDATE TASK */
export const updateTask = async (id, data) => {
  const response = await api.patch(`tasks/${id}/`, data);
  return response.data;
};

/* DELETE TASK */
export const deleteTask = async (id, password) => {
  const headers = password ? { "X-Confirm-Password": password } : {};
  await api.delete(`tasks/${id}/`, { headers, data: { password }, params: { password } });
};

/* CHANGE STATUS */
export const changeTaskStatus = async (id, data) => {
  const response = await api.post(`tasks/${id}/change-status/`, data);
  return response.data;
};

/* ASSIGN TO PROJECT */
export const assignTaskToProject = async (id, data) => {
  const response = await api.post(`tasks/${id}/assign-project/`, data);
  return response.data;
};

/* ASSIGN TO TEAM */
export const assignTaskToTeam = async (id, data) => {
  const response = await api.post(`tasks/${id}/assign-team/`, data);
  return response.data;
};

/* ASSIGN TO EMPLOYEE */
export const assignTaskToEmployee = async (id, data) => {
  const response = await api.post(`tasks/${id}/assign-employee/`, data);
  return response.data;
};

/* ATTACHMENTS */
export const getTaskAttachments = async (id) => {
  const response = await api.get(`tasks/${id}/attachments/`);
  return response.data;
};

export const uploadTaskAttachment = async (id, formData) => {
  const response = await api.post(`tasks/${id}/attachments/`, formData);
  return response.data;
};

export const deleteTaskAttachment = async (taskId, attachmentId) => {
  await api.delete(`tasks/${taskId}/attachments/${attachmentId}/`);
};

/* COMMENTS */
export const getTaskComments = async (id) => {
  const response = await api.get(`tasks/${id}/comments/`);
  return response.data;
};

export const addTaskComment = async (id, data) => {
  const response = await api.post(`tasks/${id}/comments/`, data);
  return response.data;
};

export const updateTaskComment = async (taskId, commentId, data) => {
  const response = await api.patch(`tasks/${taskId}/comments/${commentId}/`, data);
  return response.data;
};

export const deleteTaskComment = async (taskId, commentId) => {
  await api.delete(`tasks/${taskId}/comments/${commentId}/`);
};

/* OVERDUE */
export const getOverdueTasks = async (params = {}) => {
  const response = await api.get("tasks/overdue/", { params });
  return response.data;
};

/* TASKS BY PROJECT */
export const getTasksByProject = async (projectId) => {
  const response = await api.get("tasks/by-project/", { params: { project: projectId } });
  return response.data;
};
